/**
 * sw-pr-gw-customer-dashboard
 * SpendWyze Payment Request Gateway Customer Dashboard
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { PayerAttendedPaymentRequestTaskInput } from '../model/payerAttendedPaymentRequestTaskInput';
import { PayerAttendedPaymentRequestTaskResponse } from '../model/payerAttendedPaymentRequestTaskResponse';
import { PaymentRequestTask } from '../model/paymentRequestTask';
import { UnattendedPaymentRequestTaskInput } from '../model/unattendedPaymentRequestTaskInput';
import { UnattendedPaymentRequestTaskResponse } from '../model/unattendedPaymentRequestTaskResponse';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BillingReport } from '../model/billingReport';


@Injectable()
export class PaymentRequestTaskService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * Returns billing report.
     * @param month Selected month
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getBillingReport(contentType: string, month: string, observe?: 'body', reportProgress?: boolean): Observable<BillingReport | string>;
    public getBillingReport(contentType: string, month: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BillingReport | string>>;
    public getBillingReport(contentType: string, month: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BillingReport | string>>;
    public getBillingReport(contentType: string, month: string, observe?: 'body', reportProgress?: boolean): Observable<BillingReport | string>;
    public getBillingReport(contentType: string, month: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BillingReport | string>>;
    public getBillingReport(contentType: string, month: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BillingReport | string>>;
    public getBillingReport(contentType: string, month: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (month === null || month === undefined) {
            throw new Error('Required parameter month was null or undefined when calling getBillingReport.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (month !== undefined && month !== null) {
            queryParameters = queryParameters.set('month', <any>month);
        }

        let headers = this.defaultHeaders;

        // authentication (AccessTokenSecurity) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/csv',
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        headers = headers.set('Content-Type', contentType);

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        if (contentType === 'text/csv') {
            return this.httpClient.request('get',`${this.basePath}/billing-report`,
                {
                    params: queryParameters,
                    withCredentials: this.configuration.withCredentials,
                    headers: headers,
                    observe: observe,
                    reportProgress: reportProgress,
                    responseType: 'blob'
                }
            );
        } else {
            return this.httpClient.request('get',`${this.basePath}/billing-report`,
                {
                    params: queryParameters,
                    withCredentials: this.configuration.withCredentials,
                    headers: headers,
                    observe: observe,
                    reportProgress: reportProgress
                }
            );
        }
    }

    /**
     * 
     * Returns payment request tasks.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTasks(observe?: 'body', reportProgress?: boolean): Observable<Array<PaymentRequestTask>>;
    public getTasks(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<PaymentRequestTask>>>;
    public getTasks(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<PaymentRequestTask>>>;
    public getTasks(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (AccessTokenSecurity) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<PaymentRequestTask>>('get',`${this.basePath}/tasks`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Initiate a payment request task in Payer Attended mode.
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public initPayerAttended(body?: PayerAttendedPaymentRequestTaskInput, observe?: 'body', reportProgress?: boolean): Observable<PayerAttendedPaymentRequestTaskResponse>;
    public initPayerAttended(body?: PayerAttendedPaymentRequestTaskInput, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PayerAttendedPaymentRequestTaskResponse>>;
    public initPayerAttended(body?: PayerAttendedPaymentRequestTaskInput, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PayerAttendedPaymentRequestTaskResponse>>;
    public initPayerAttended(body?: PayerAttendedPaymentRequestTaskInput, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (AccessTokenSecurity) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<PayerAttendedPaymentRequestTaskResponse>('post',`${this.basePath}/tasks/payment-request/payer-attended`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Initiate a payment request task in Unattended mode.
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public initUnattended(body?: UnattendedPaymentRequestTaskInput, observe?: 'body', reportProgress?: boolean): Observable<UnattendedPaymentRequestTaskResponse>;
    public initUnattended(body?: UnattendedPaymentRequestTaskInput, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UnattendedPaymentRequestTaskResponse>>;
    public initUnattended(body?: UnattendedPaymentRequestTaskInput, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UnattendedPaymentRequestTaskResponse>>;
    public initUnattended(body?: UnattendedPaymentRequestTaskInput, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (AccessTokenSecurity) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<UnattendedPaymentRequestTaskResponse>('post',`${this.basePath}/tasks/payment-request/unattended`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Recall a payment request task.
     * @param taskId Unique identifier of the payment request task.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public recall(taskId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public recall(taskId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public recall(taskId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public recall(taskId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (taskId === null || taskId === undefined) {
            throw new Error('Required parameter taskId was null or undefined when calling recall.');
        }

        let headers = this.defaultHeaders;

        // authentication (AccessTokenSecurity) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('post',`${this.basePath}/tasks/${encodeURIComponent(String(taskId))}/recall`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
